/* global axios */
import ApiClient from './ApiClient';

class KanbanAPI extends ApiClient {
  constructor() {
    super('kanban', { accountScoped: true });
  }

  getFunnels() {
    return axios.get(`${this.url}/funnels`);
  }

  createFunnel(funnel) {
    return axios.post(`${this.url}/funnels`, { funnel });
  }

  updateFunnel(id, funnel) {
    return axios.patch(`${this.url}/funnels/${id}`, { funnel });
  }

  deleteFunnel(id) {
    return axios.delete(`${this.url}/funnels/${id}`);
  }

  getBoard(params) {
    return axios.get(`${this.url}/board`, { params });
  }

  // target: { status } or { kanban_stage_id }; expected: the position the user saw
  moveConversation(conversationId, target, expected) {
    return axios.patch(
      `${this.baseUrl()}/conversations/${conversationId}/kanban`,
      { ...target, expected }
    );
  }

  getScheduledMessages(conversationId) {
    return axios.get(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`
    );
  }

  createScheduledMessage(
    conversationId,
    { content, scheduledAt, attachment, templateParams }
  ) {
    const payload = new FormData();
    if (content) payload.append('content', content);
    payload.append('scheduled_at', scheduledAt);
    if (attachment) payload.append('attachment', attachment);
    if (templateParams) {
      payload.append('template_params', JSON.stringify(templateParams));
    }
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages`,
      payload
    );
  }

  cancelScheduledMessage(conversationId, id) {
    return axios.delete(
      `${this.baseUrl()}/conversations/${conversationId}/scheduled_messages/${id}`
    );
  }
}

export default new KanbanAPI();
